import React from 'react';
import { Icon } from 'js/components/common/Icon';
import style from './index.scss';

export default ({
    className = '',
    isVisible,
    onClick,
    ...props // data attributes
}) => (
    <Icon
        className={`${style.icon} ${className} ${isVisible ? '' : 'secured'}`}
        type="formFieldEye"
        onClick={onClick}
        {...props}
    />
);
